import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import { getStats } from "../../components/helpers/StatsHelpers";
import {
  RiQuestionLine,
  RiUserAddLine,
  RiUserFill,
  RiBookMarkedFill,
  RiFolderMusicLine,
  RiSettings3Line,
  RiLockPasswordLine,
  RiPriceTag3Line,
  RiCalendarLine,
  RiShare2Line,
  RiAddCircleLine,
  RiArrowUpDownLine,
} from "react-icons/ri";
import '../../the-worship-bible-2.css';
import {SeoHelper} from "../../components/helpers/SeoHelper";

class Help extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
        <>
          <SeoHelper
              uri="/help"
              title = "Help | The Worship Bible"
              description={"Get help with all aspects of creating worship song-flows from scripture, themes and lectionaries."}
          />
          <div className="position-relative">
            {/* Hero Section */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building Your Song-Flows{" "}
                        <span>Help & Support</span>
                      </h1>
                      <p className="lead text-white mt-4">
                        Need assistance? Explore our guides to get started with creating your worship song-flows effortlessly.
                      </p>
                    </Col>
                  </Row>
                </div>
              </Container>
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon className="fill-white" points="2560 0 2560 100 0 100" />
                </svg>
              </div>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200" id="help-content">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0 help-card">
                        <CardBody className="py-5">
                          <div className="d-flex align-items-center mb-4">
                            <RiQuestionLine color="#5e72e4" size="36" className="mr-2" />
                            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                              Help & Resources
                            </h2>
                          </div>
                          <p className="description mt-3">
                            Building your song-flows is easy and intuitive at The Worship Bible, but we understand that a little extra help might be useful. Below are some starting points to get you going.
                          </p>
                          {/* Grid of Help Topic Cards */}
                          <Row className="mt-5">
                            <Col md="6" className="mb-4">
                              <a href="/help/how-to-register" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiUserAddLine color="#5e72e4" size="24" className="mr-2" />
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">How to register</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Step-by-step guide on creating a new account.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/how-to-sign-in" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiUserFill color="#5e72e4" size="24" className="mr-2" />
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">How to sign in</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Explains the process of logging into your account using your registered credentials.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/creating-your-first-curated-song-flow" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiFolderMusicLine color="#5e72e4" size="24" className="mr-2" />
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Creating your first curated song-flow</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Walks you through the process of building your initial curated song-flow from scratch.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/create-a-curated-song-flow-from-scripture" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiBookMarkedFill color="#5e72e4" size="24" className="mr-2" />
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Create a curated song-flow from Scripture</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Details how to generate a song-flow by selecting and integrating scripture passages.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/how-to-reset-your-password" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiLockPasswordLine color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">How to reset your password</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Step-by-step guide to resetting your password if you have forgotten it.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/create-a-curated-song-flow-from-a-theme" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiPriceTag3Line color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Create a curated song-flow from a Theme</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Details how to generate a song-flow by selecting one or more worship themes.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/create-a-curated-song-flow-from-a-lectionary" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiCalendarLine color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Create a curated song-flow from a Lectionary</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      Explains how to use a Lectionary (Methodist, RCL, or Church of England) to build a song-flow. Requires a paid account.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/saving-and-managing-your-song-flows" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiFolderMusicLine color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Saving and managing your song-flows</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      How to save, access, and manage your curated song-flows as a registered member.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/sharing-a-song-flow" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiShare2Line color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Sharing a song-flow</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      How to share a curated song-flow with your team or church by email.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/adding-songs-from-multiple-sources" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiAddCircleLine color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Adding songs from multiple sources</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      How to build a richer song-flow by adding songs from Scripture, themes, and lectionary readings together.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="6" className="mb-4">
                              <a href="/help/reordering-songs-in-your-song-flow" className="text-decoration-none">
                                <Card className="help-topic-card shadow border-0 h-100">
                                  <CardBody className="p-4">
                                    <div className="d-flex align-items-center mb-3">
                                      <RiArrowUpDownLine color="#5e72e4" size="24" className="mr-2"/>
                                      <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Reordering songs in your song-flow</h2>
                                    </div>
                                    <p className="text-muted mb-0">
                                      How to drag and rearrange songs in your curated song-flow to create the right worship flow.
                                    </p>
                                  </CardBody>
                                </Card>
                              </a>
                            </Col>
                            <Col md="12" className="mb-4">
                              <Card className="help-topic-card shadow border-0 h-100">
                                <CardBody className="p-4">
                                  <div className="d-flex align-items-center mb-3">
                                    <RiQuestionLine color="#5e72e4" size="24" className="mr-2" />
                                    <h2 style={{fontSize: '1rem'}} className="text-primary mb-0">Please bear with us</h2>
                                  </div>
                                  <p className="text-muted mb-0">
                                    We are continually adding new features to our website, that includes help tutorials and articles.
                                    If there is something specific that you need help with please <a href="/contact-us">contact us</a> and
                                    we'll help you out and/or point you in the right direction to get you moving as quickly as possible.
                                  </p>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        </>
    );
  }
}

export default Help;